var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"notif",staticClass:"custom-notification"},[(_vm.UnreadMessagesCount)?_c('notification-bell',{attrs:{"count":_vm.UnreadMessagesCount,"counterLocation":"lowerLeft","iconColor":"white","counterBackgroundColor":"red","counterTextColor":"white","counterStyle":"round","size":25,"upperLimit":500,"fontSize":"14px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }